<article>
  <header>
    <strong>Análise de Sentimento</strong>
    <section>
      <app-primary-button
        *ngIf="hasSupervisorRole"
        label="Gerar"
        icon="assets/icons/download-2.svg"
        [color]="ButtonColorEnum.common"
        (clickFunc)="navigateToNewForm()"
      ></app-primary-button>
    </section>
  </header>
  <main>
    <app-sa_report-list-header></app-sa_report-list-header>
    <ng-container *ngIf="isLoading">
      <div *ngFor="let i of [1, 2, 3, 4, 5]" class="skeleton">
        <div class="skeleton-column">
          <div class="skeleton-item"></div>
        </div>
      </div>
    </ng-container>
    <app-sa_report-list-item
      *ngFor="let form of sa_reportList"
      [data]="form"
    ></app-sa_report-list-item>
    <app-paginator
      [page]="page"
      [totalPages]="totalPages"
      [elementsShowing]="sa_reportList.length"
      [totalElements]="totalItems"
      (selectPageFunc)="handleSelectPage($event)"
    ></app-paginator>
  </main>
</article>
